import router from '../../router/index'
import axios from 'axios'
import url from '../../urls'

export default {
  GET_DB_LIST({ commit }) {
    commit('GET_DB_LIST_LOADING', true)
    axios({
      method: 'GET',
      url: url.GET_DB_LIST_URL
    })
      .then(response => {
        commit('GET_DB_LIST_SUCCESS', response.data.result)
        commit('GET_DB_LIST_LOADING', false)
      })
      .catch(error => {
        if (error.response) {
          commit('GET_DB_LIST_ERROR', error.response.data.message)
          commit('GET_DB_LIST_LOADING', false)
        }
      })
  },
  GET_DB_LIST_NOT_NULL_SCHEMA({ commit }) {
    axios({
      method: 'GET',
      url: url.GET_DB_LIST_NOT_NULL_SCHEMA_URL
    })
      .then(response => {
        commit('GET_DB_LIST_SUCCESS', response.data.result)
      })
      .catch(error => {
        if (error.response) {
          commit('GET_DB_LIST_ERROR', error.response.data.message)
        }
      })
  },
  CREATE_NEW_DB({ commit, state }, dbName) {
    commit('LOADING_NEW_DB_BTN', true)
    return axios({
      method: 'POST',
      url: url.CREATE_NEW_DB_URL,
      data: dbName
    })
      .then(response => {
        commit('CREATE_NEW_DB_SUCCESS', response.data)
        router.push({
          path: `/main/constructor/edit/${response.data.id}`
        })
        commit('LOADING_NEW_DB_BTN', false)
      })
      .catch(error => {
        if (error.response) {
          commit('CREATE_NEW_DB_ERROR', error.response.data.message)
          commit('LOADING_NEW_DB_BTN', false)
        }
      })
  },
  CREATE_CONSTRUCTOR_SCHEMA({ commit, state }, data) {
    commit('LOADING_SAVE_SCHEMA_BTN', true)
    const dbId = state.newDb.id
    console.log('new-schema :', data)
    axios({
      method: 'POST',
      url: `${url.SAVE_CONSTRUCTOR_DATA_URL}/${dbId}`,
      data
    })
      .then(response => {
        if (response.status === 200 && response.statusText === 'OK') {
          router.push({
            path: '/main/constructor/list'
          })
        }
        commit('LOADING_SAVE_SCHEMA_BTN', false)
      })
      .catch(error => {
        console.log(error)
        commit('LOADING_SAVE_SCHEMA_BTN', false)
      })
  },
  GET_SCHEMA({ commit }, id) {
    axios({
      method: 'GET',
      url: `${url.GET_SCHEMA_URL}/${id}`
    })
      .then(response => {
        commit('GET_SCHEMA_SUCCESS', response.data.result)
      })
      .catch(error => {
        if (error.response) {
          console.log('get-schema-error: ', error)
          commit('GET_SCHEMA_ERROR', error.response.data.message)
        }
      })
  },
  EDIT_SCHEMA({ commit, state }, data) {
    axios({
      method: 'POST',
      url: `${url.SAVE_CONSTRUCTOR_DATA_URL}/${data.id}`,
      data: data.object
    })
      .then(response => {
        // console.log(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  REMOVE_DB({ commit, dispatch }, id) {
    commit('DELETE_DB_LOADING', true)
    return axios({
      method: 'DELETE',
      url: url.DELETE_DB_URL + `${id}`
    })
      .then(response => {
        commit('DELETE_DB_SUCCESS', response.data)
        dispatch('GET_DB_LIST')
        commit('DELETE_DB_LOADING', false)
      })
      .catch(error => {
        commit('DELETE_DB_ERROR', error.response)
        commit('DELETE_DB_LOADING', false)
      })
  },
  EDIT_DB_NAME({ commit, dispatch }, data) {
    commit('EDIT_DB_NAME_LOADING', true)
    return axios({
      method: 'POST',
      url: url.EDIT_DB_NAME_URL,
      data
    })
      .then(response => {
        commit('EDIT_DB_NAME_SUCCESS', response)
        commit('EDIT_DB_NAME_LOADING', false)
        dispatch('GET_DB_LIST')
      })
      .catch(error => {
        commit('EDIT_DB_NAME_ERROR', error.response.data.message)
        commit('EDIT_DB_NAME_LOADING', false)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/dbConstructor/actions.js